import { useEffect, useState } from 'react'
import type { Action } from '../../domain/action'
import { missionRace, type Objective } from '../../domain/objective'
import { useI18n } from '../../i18n'
import { missionCopy } from '../missionCopy'

export const useMissionClock = () => {
  const [now, setNow] = useState(Date.now)
  useEffect(() => {
    const refresh = () => setNow(Date.now())
    const timer = window.setInterval(refresh, 60_000)
    document.addEventListener('visibilitychange', refresh)
    return () => { window.clearInterval(timer); document.removeEventListener('visibilitychange', refresh) }
  }, [])
  return now
}

export const MissionRaceTracks = ({ objective, actions, compact = false, now }: { objective: Objective; actions: Action[]; compact?: boolean; now: number }) => {
  const { language } = useI18n()
  const c = missionCopy[language]
  const race = missionRace(objective, actions, now)
  const progress = Math.round(race.progress * 100)
  const time = Math.round(race.time * 100)
  return <div className={`mission-race__lanes${compact ? ' mission-race__lanes--compact' : ''}`}>
    <div className="mission-race__lane mission-race__lane--you">
      <div className="mission-race__labels"><span>{c.you}{!compact && ` · ${race.completed}/${race.steps.length} ${c.steps}`}</span><strong>{progress}%</strong></div>
      <div className="mission-race__track" role="progressbar" aria-label={c.you} aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}><span style={{ width: `${progress}%` }} /><b style={{ left: `${progress}%` }} aria-hidden="true">➤</b></div>
    </div>
    {objective.deadline && <div className="mission-race__lane mission-race__lane--time">
      <div className="mission-race__labels"><span>{c.time}</span><strong>{time}%</strong></div>
      <div className="mission-race__track" role="progressbar" aria-label={c.time} aria-valuenow={time} aria-valuemin={0} aria-valuemax={100}><span style={{ width: `${time}%` }} /><b style={{ left: `${time}%` }} aria-hidden="true">◷</b></div>
    </div>}
  </div>
}
